/**
 * Parses a human-readable timeout string (e.g. "30 seconds", "2 minutes") into
 * milliseconds. Returns `undefined` if the format is unrecognized.
 *
 * Expected format: "<number> <unit>" where unit is "second(s)" or "minute(s)".
 */
export const parseTimeoutToMs = (
  timeout: string | null | undefined,
): number | undefined => {
  if (!timeout) {
    return undefined;
  }

  const match = timeout.match(/^(\d+)\s+(seconds?|minutes?)$/i);

  if (!match) {
    return undefined;
  }

  const value = Number(match[1]);
  const unit = match[2].toLowerCase();

  if (unit.startsWith('minute')) {
    return value * 60 * 1000;
  }

  return value * 1000;
};
